// src/features/system/orchestrator/api/workersApi.ts
import { bff } from '@/lib/http/bff';

export interface Worker {
  worker_id: number;
  worker_key: string;
  worker_kind: string;
  transport: string;
  /** Back-compat single endpoint (older API payloads) */
  endpoint?: string;
  /** Preferred: multiple endpoints (newer API payloads) */
  endpoints?: string[];
  region: string | null;
  is_active: boolean;
  created_at: string;
}

export interface ListWorkersParams {
  active?: boolean;
}

export const fetchWorkersApi = (params: ListWorkersParams = {}): Promise<Worker[]> => {
  const qs = params.active === undefined ? undefined : { active: params.active };
  return bff.get<Worker[]>('/orchestrator/workers', qs);
};

export interface ListWorkersV2Response {
  as_of?: string;
  items: Worker[];
  next_cursor?: string | null;
}

export interface ListWorkersV2Params {
  limit?: number;
  cursor?: string;
  tenant_id?: number;
  registry_fallback?: boolean;
}

export const fetchWorkersV2Api = (params: ListWorkersV2Params = {}): Promise<ListWorkersV2Response> => {
  return bff.get<ListWorkersV2Response>('/orchestrator/workers/v2', params as any);
};

export interface CreateWorkerInput {
  worker_key: string;
  worker_kind: string;
  transport: string;
  endpoint: string;
  region?: string;
  is_active?: boolean;
}

export const createWorkerApi = (payload: CreateWorkerInput): Promise<Worker> =>
  bff.post<Worker>('/orchestrator/workers', payload);
